import { environment } from 'src/environments/environment';
import { AppType } from 'src/environments/environmentTypes';

/**
 * authorize
 * でアクセスする場合は自身の設定したcloudfrontに飛ばされてしまうので
 * authorize/
 * でアクセスさせることでAuth0の本ドメインに飛ばす
 * @returns
 */
export function toAuth0DomainAuthorize() {
  return `https://${environment.domain}/authorize/${location.search}`;
}

export function extractRole(redirectUri: string) {
  return redirectUri.split('?')[1] || '';
}

export function loadSavedQuery() {
  const savedQueryParams = JSON.parse(
    sessionStorage.getItem(environment.sessionStorageKey)
  );
  return savedQueryParams;
}

export function applications(): {
  clientId: string;
  domain: string;
  logo: string;
  title: string;
  pageTitle: string;
  type: AppType;
}[] {
  const result: any[] = [];
  for (const clientId of Object.keys(environment.apps)) {
    const app = environment.apps[clientId];
    app.clientId = clientId;
    result.push(app);
  }
  return result;
}

export function baseUrl(clientId: string) {
  const customBaseUrl = environment.apps[clientId]?.customDomainConfig?.baseUrl;
  if (customBaseUrl) return customBaseUrl;
  return environment.baseUri;
}

export const errorDescriptionsMap = {
  'Wrong email or password.': 'Eメールアドレス、パスワードに誤りがあります',
  'Missing credentials': 'Eメールアドレス、パスワードを入力してください',
  "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.":
    '一定回数以上連続でログインに失敗したため、ログイン機能を一時的にロックしました。解除方法を登録メールアドレスにてご案内しました。',
  "Your account has been blocked after multiple consecutive login attempts. We've sent you a notification via your preferred contact method with instructions on how to unblock it.":
    '一定回数以上連続でログインに失敗したため、ログイン機能を一時的にロックしました。解除方法を登録メールアドレスにてご案内しました。',
};

export function getOptionsFromRedirectUri(redirectUri: string): {
  email?: string;
  option?: string;
  cpNoCodeInput?: boolean;
  /**
   * セッション切れでログイン画面にリダイレクトされた場合を示すフラグ
   * @link https://doctors-jp.backlog.com/view/DXUT-222
   */
  isSessionExpired?: boolean;
} {
  const queryString = redirectUri?.split('?')[1];
  const params = new URLSearchParams(queryString);

  const email = params.get('email') || undefined; // https://doctors-jp.backlog.com/view/CBPT-3225向け
  const no_code_input = params.has('cp_no_code_input');
  const isSessionExpired = params.has('session_expired');
  return {
    email: email ? decodeURIComponent(decodeURIComponent(email)) : undefined, // 復元するためにdecodeの二重がけが必要
    option: params.get('option') || undefined,
    cpNoCodeInput: no_code_input ? true : undefined, // https://doctors-jp.backlog.com/view/CBPT-4152
    isSessionExpired: isSessionExpired ? true : undefined,
  };
}

export function combinations<T>(arr: T[], k: number): T[][] {
  const result: T[][] = [];

  // 再帰的なヘルパー関数
  function combineUtil(temp: T[], start: number, k: number) {
    // 現在の組み合わせがkに達したら結果に追加
    if (k === 0) {
      result.push([...temp]);
      return;
    }

    // 配列の各要素を試してみる
    for (let i = start; i <= arr.length - k; i++) {
      temp.push(arr[i]);
      // 残りの要素からk-1個の組み合わせを再帰的に探す
      combineUtil(temp, i + 1, k - 1);
      // 戻ってきたら追加した要素を削除して次の要素を試す
      temp.pop();
    }
  }

  combineUtil([], 0, k);
  return result;
}

export function toUrl(params: {
  clientId: string;
  path:
  | 'login'
  | 'register'
  | 'forgot-password'
  | 'password-reset-send'
  | 'register-resend';
}) {
  return `${environment.baseUri}/${params.path}/?client_id=${params.clientId}`;
}
